import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { ActivationAlertsContractNewsTopic } from "@similarweb/pro-api-client";

import type { ValueMap } from "../../filters/types";
import type { NewsType } from "../types";

import { NEWS_TYPES, TOPICS } from "./constants";

const INITIAL_NEWS_TYPES: ValueMap<NewsType> = new Map([
    ["Story", { id: "Story", label: "Story" }],
    ["PR", { id: "PR", label: "PR" }],
]);

interface INewsAlertsFilterState {
    isDefaultNewsTypesSelected: boolean;
    isDefaultTopicsSelected: boolean;
    searchValue: string;
    selectedNewsTypes: ValueMap<NewsType>;
    selectedTopics: ValueMap<ActivationAlertsContractNewsTopic>;
}

interface INewsAlertsFilterStore extends INewsAlertsFilterState {
    reset: () => void;
    setSearchValue: (value: string) => void;
    setSelectedNewsTypes: (types: ValueMap<NewsType>) => void;
    setSelectedTopics: (topics: ValueMap<ActivationAlertsContractNewsTopic>) => void;
}

const initialState: INewsAlertsFilterState = {
    isDefaultNewsTypesSelected: false,
    isDefaultTopicsSelected: true,
    searchValue: "",
    selectedTopics: new Map(),
    selectedNewsTypes: INITIAL_NEWS_TYPES,
};

export const useNewsAlertsFilterStore = create<INewsAlertsFilterStore>()(
    devtools(
        (set) => ({
            ...initialState,
            reset: () => set(initialState),
            setSearchValue: (value) => set({ searchValue: value }),
            setSelectedNewsTypes: (types) =>
                set({
                    selectedNewsTypes: types,
                    isDefaultNewsTypesSelected: types.size === NEWS_TYPES.length || !types.size,
                }),
            setSelectedTopics: (topics) =>
                set({
                    selectedTopics: topics,
                    isDefaultTopicsSelected: topics.size === TOPICS.length || !topics.size,
                }),
        }),
        { name: "NewsAlertsFilterStore" },
    ),
);
